import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: process.env['NEXT_PUBLIC_GA'] || '',
};
// With NEXT_PUBLIC_GA unset, TagManager still injects `gtm.js?id=` and the browser spends a
// request on a script that does nothing, so both entry points bail out without an id.
const hasGtmId = !!tagManagerArgs.gtmId;
const init = () => {
  if (!hasGtmId) return;
  TagManager.initialize(tagManagerArgs);
};
const sendGAEvent = (optionsOrName: string) => {
  if (!hasGtmId) return;
  TagManager.initialize({
    ...tagManagerArgs,
    events: {
      sendUserInfo: optionsOrName,
    },
  });
};
const useGoogleAnalytics = () => {
  useEffect(() => {
    init();
  }, []);
};
export { useGoogleAnalytics, sendGAEvent };
